import { ValidationResult } from '../types/ValidationResult';

export const createValidResult = (): ValidationResult => ({ isValid: true, failures: [] });
